module.exports = __webpack_public_path__ + "img/fringe-brush.e7b7a4c4.png";